import { invokeRPC } from './socket.js'

export function getProjectPreviewUploadToken(projectId) {
  return invokeRPC('project', 'getProjectPreviewUploadToken', { id: projectId })
}

export function createProject(data) {
  return invokeRPC('project', 'createProject', data)
}

export function getProjectsByCustomer(customerId) {
  return invokeRPC('project', 'getProjectsByCustomer', { customer_id: customerId })
}

export function getProjectsByCustomerForGrid(customerId) {
  return invokeRPC('project', 'getProjectsByCustomerForGrid', { customer_id: customerId })
}

export function getProjectListForUser() {
  return invokeRPC('project', 'getProjectListForUser')
}

export function getProject(projectId) {
  return invokeRPC('project', 'getProject', { project_id: projectId })
}

export function getReferenceFilesByCustomer(customerId) {
  const data = {}
  if (customerId) {
    data.customer_id = customerId
  }
  return invokeRPC('project', 'getReferenceFilesByCustomer', data)
}

export function getFileShareingByCustomer(customerId) {
  const data = {}
  if (customerId) {
    data.customer_id = customerId
  }
  return invokeRPC('project', 'getFileSharingByCustomer', data)
}

export function updateProject(data) {
  return invokeRPC('project', 'updateProject', data)
}

export function updateProjectTagLine(projectId, tagLine) {
  return invokeRPC('project', 'updateProjectTagLine', {
    project_id: projectId,
    tag_line: tagLine
  })
}

export function deleteProject(projectId) {
  return invokeRPC('project', 'deleteProject', { project_id: projectId })
}

export function deletePreviewImage(projectId) {
  return invokeRPC('project', 'deletePreviewImage', { project_id: projectId })
}

export function setMaintenanceMode(projectId, mode) {
  return invokeRPC('project', 'setMaintenanceMode', {
    project_id: projectId,
    mode: mode
  })
}

export function updateProjectOrder(order) {
  return invokeRPC('project', 'updateProjectOrder', { order: order })
}

export function recordProjectUsage(data) {
  return invokeRPC('project', 'recordProjectUsage', data)
}

export function getLatestUsedProjects(userId) {
  return invokeRPC('project', 'getLatestUsedProjects', { user_id: userId })
}

export function isPowerPointPublished(projectId) {
  return invokeRPC('project', 'isPowerPointPublished', { project_id: projectId })
}